
// js队列
class vocieQueue {
    constructor() {
        this.queue = [];
    }

    // 入队
    enqueue(item) {

        this.queue.push(item);

    }

    // 出队
    dequeue() {
        return this.queue.shift();
    }

    // 获取队列长度
    get length() {
        return this.queue.length;
    }

    // 判断队列是否为空
    isEmpty() {
        return this.queue.length === 0;
    }
    //  返回队列中的第一个元素
    getFirst() {
        return this.queue[0];
    }
    clearAll() {
        this.queue = [];
    }

}
const voicequeue = new vocieQueue();
export default voicequeue